
import React from "react";

import { connect } from 'react-redux';
import {createSingleEntry} from '../actions/index'


import NotificationAlert from "react-notification-alert";
// reactstrap components
import {
  Button,
  Card,
  CardTitle,
  CardFooter,
  CardHeader,
  CardBody,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";


class InputField extends React.Component {
  state = {
    date: '',
    duration: 30,
    distance: 5000,
    heartRate:175,
    up:0,
    down:0,

  }


  notify(place,message) {
    if (!message){
      return ""
    }
    var color = message[0];
    var type;
    switch (color) {
      case 'success':
        type = "success";
        break;
      case 'danger':
        type = "danger";
        break;
      default:
        break;
    }
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div style={{height:'70px'}}>
            {message[1]}
          </div>
          
        </div>
      ),
      type: type,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 10,
    };
    this.refs.notificationAlert.notificationAlert(options);
  }
  componentDidUpdate(prevProps){
    if(prevProps.message.message !== this.props.message.message && this.props.message.message){
        this.notify("br",this.props.message.message)
    }
  }
  runningIndex = () => {
    
    var max_hr = this.props.auth.max_hr
    var x = this.state.heartRate/max_hr*1.45-0.30
    var d = Number(this.state.distance) + Number(6*this.state.up - 4*this.state.down)
    var RIO = (213.9/this.state.duration) * Math.pow(d/1000,1.06) +3.5
    var runningIndex = RIO/x
    return runningIndex.toFixed(2)
    
  }
  trimpTss = () => {
    var rest_hr = this.props.auth.rest_hr
    var max_hr = this.props.auth.max_hr
    var lactate_th = this.props.auth.lactate_th
    //calculate trimp and tss
    var hrr = (this.state.heartRate-rest_hr)/(max_hr-rest_hr)
    var trimp=0
    Math.round(this.state.duration)
    for (var i=0;i<this.state.duration;i++){
        trimp = trimp + 1 * hrr * 0.64 * Math.exp(1.92 * hrr)
    }
    
    var hr_lthr = (lactate_th - rest_hr)/(max_hr - rest_hr)
    var hour_lthr = 60 * hr_lthr * 0.64 * Math.exp(1.92 * hr_lthr)
    var tss =  (trimp/hour_lthr)*100
    
    return [tss.toFixed(2),trimp]
  }
  sendActivityToAction = () => {
    const activity = this.state
    activity.runningIndex = this.runningIndex()
    const [tss,trimp] = this.trimpTss()
    activity.tss = tss
    activity.trimp = trimp
    //console.log(activity)
    this.props.createSingleEntry(activity)
  }
  render() {
    //console.log("state",this.state,"redux",this.props.auth)
    return (
      <>
      <NotificationAlert ref="notificationAlert" />
        <PanelHeader size="sm" />
        <div className="content">
        
          <Row>
            <Col md="12">
              <Card style={{backgroundColor:'rgba(30,30,30,1)',color:'rgb(255,255,255)'}} align={'center'}>
                <CardHeader>
                  <h5 className="title">Activity Input</h5>
                </CardHeader>
                <CardBody>
                  <Form align={'center'}>
                    <Row>
                           
                      <Col className="pr-3" md="3">
                        
                      </Col>
                      <Col className="pr-3" md="6">
                            <label>Activity Type</label>
                            <Input className="text-info" type="select" value={this.state.measurementSystem} onChange={e => this.setState({measurementSystem:e.target.value})}>
                            <option>Running</option>
                            
                            </Input> 
                      </Col>
                      <Col className="pr-3" md="3"></Col>
                      <Col className="pr-3" md="3">
                        
                      </Col>
                      <Col className="pr-3" md="6">
                        <label>Date</label>
                        <Input className="text-info" type="date" value={this.state.date} onChange={e => this.setState({date:e.target.value})}/> 
                      </Col>
                      <Col className="pr-3" md="3">
                      
                      </Col>
                      <Col className="pr-3" md="3">
                        
                      </Col>
                      <Col className="pr-3" md="6">
                        <label>Distance (meters)</label>
                        <Input className="text-info" type="number" value={this.state.distance} onChange={e => this.setState({distance:e.target.value})}/> 
                      </Col>
                      <Col className="pr-3" md="3">
                      
                      </Col>
                      <Col className="pr-3" md="3">
                        
                      </Col>
                      <Col className="pr-3" md="6">
                        <label>Duration (minutes)</label>
                        <Input className="text-info" type="number" value={this.state.duration} onChange={e => this.setState({duration:e.target.value})}/> 
                      </Col>
                      <Col className="pr-3" md="3">
                      
                      </Col>
                      <Col className="pr-3" md="3">
                        
                      </Col>
                      <Col className="pr-3" md="6">
                        <label>Avg Heart rate</label>
                        <Input className="text-info" type="number" value={this.state.heartRate} onChange={e => this.setState({heartRate:e.target.value})}/> 
                      </Col>
                      <Col className="pr-3" md="3">
                      
                      </Col>
                      <Col className="pr-3" md="3">
                        
                      </Col>
                      <Col className="pr-3" md="6">
                        <label>Elevation ascent (meters)</label>
                        <Input className="text-info" type="number" value={this.state.up} onChange={e => this.setState({up:e.target.value})}/> 
                      </Col>
                      <Col className="pr-3" md="3">
                      
                      </Col>
                      <Col className="pr-3" md="3">
                        
                      </Col>
                      <Col className="pr-3" md="6">
                        <label>Elevation descent (meters)</label>
                        <Input className="text-info" type="number" value={this.state.down} onChange={e => this.setState({down:e.target.value})}/> 
                      </Col>
                     
                      
                    </Row>
                    
                    
                    
                  </Form>
                  <Row style={{marginTop:'20px'}}>
                    <Col xs={12} md={6}>
                            <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                                <CardHeader>
                                    <h5 className="card-category" className="text-white">Performance Index</h5>
                                    <CardTitle tag="h4" className='text-info'>{this.runningIndex()}</CardTitle>
                                </CardHeader>
                
                                <CardFooter>
                                    <div className="stats">
                                        
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>
                        <Col xs={12} md={6}>
                        <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                            <CardHeader>
                                <h5 className="card-category" className="text-white">Stress Score</h5>
                                <CardTitle tag="h4" className='text-warning'>{this.trimpTss()[0]}</CardTitle>
                            </CardHeader>
               
                            <CardFooter>
                                <div className="stats">
                                    
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                  </Row>
                    
            
                  <Button color='info' onClick={this.sendActivityToAction}>Save Activity</Button>
                </CardBody>
              </Card>
            </Col>
            
          </Row>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
    return {auth:state.auth,message:state.message}
  }

export default connect(mapStateToProps,{createSingleEntry})(InputField);
